import React, { useState, useEffect } from 'react';
import dayjs from 'dayjs';

const Register = () => {
  const [formData, setFormData] = useState({
    title: '',
    fullName: '',
    gender: '',
    email: '',
    phone: '',
    jobTitle: '',
    company: '',
    dietaryRestrictions: '',
    date: '',
  });

  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');

  // Set the current date in the desired format (DD/MM/YYYY HH:mm am/pm)
  useEffect(() => {
    const currentDate = dayjs().format('DD/MM/YYYY hh:mm A');
    setFormData((prevFormData) => ({
      ...prevFormData,
      date: currentDate,
    }));
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const scriptURL = 'https://script.google.com/macros/s/AKfycbyfVR7P7vyvvkiU3cLdLAmhcKrNvhRxk1CjqVsJF86N4l-44j62Bu3qR9d9XaAFzN3A6Q/exec';
    
    fetch(scriptURL, {
      method: 'POST',
      body: new URLSearchParams(formData),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.result === 'success') {
          setSuccessMessage('Registration Successful!');
          setErrorMessage('');
          setFormData({
            title: '',
            fullName: '',
            gender: '',
            email: '',
            phone: '',
            jobTitle: '',
            company: '',
            dietaryRestrictions: '',
            date: ''
          });
        } else {
          setErrorMessage('There was a problem with your registration.');
          setSuccessMessage('');
        }
      })
      .catch((error) => {
        setErrorMessage('There was a problem with your registration.');
        setSuccessMessage('');
      });
  };

  return (
    <div className="max-w-xl mt-[150px] mx-auto mt-10 p-4 bg-gray-100 shadow-md rounded-md">
      <h1 className="text-2xl font-bold text-center mb-4">OHS Conference Registration</h1>
      <form onSubmit={handleSubmit} className="grid gap-4">
        
        {/* Title Dropdown */}
        <div>
          <label className="block text-sm font-medium">Title:</label>
          <select
            name="title"
            value={formData.title}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            <option value="">Select Title</option>
            <option value="Mr">Mr</option>
            <option value="Mrs">Mrs</option>
            <option value="Ms">Ms</option>
          </select>
        </div>

        {/* Full Name */}
        <div>
          <label className="block text-sm font-medium">Full Name:</label>
          <input
            type="text"
            name="fullName"
            value={formData.fullName}
            onChange={handleChange}
            placeholder="John kamana"
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Gender Dropdown */}
        <div>
          <label className="block text-sm font-medium">Gender:</label>
          <select
            name="gender"
            value={formData.gender}
            onChange={handleChange}
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          >
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>

        {/* Email */}
        <div>
          <label className="block text-sm font-medium">Email:</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="john@example.com"
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Phone */}
        <div>
          <label className="block text-sm font-medium">Phone:</label>
          <input
            type="tel"
            name="phone"
            value={formData.phone}
            onChange={handleChange}
            placeholder="+250 773 4567 890"
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Job Title */}
        <div>
          <label className="block text-sm font-medium">Job Title:</label>
          <input
            type="text"
            name="jobTitle"
            value={formData.jobTitle}
            onChange={handleChange}
            placeholder="Managing Director"
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Company/Institution */}
        <div>
          <label className="block text-sm font-medium">Company/Institution:</label>
          <input
            type="text"
            name="company"
            value={formData.company}
            onChange={handleChange}
            placeholder="ABC Corporation ltd"
            required
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Dietary Restrictions */}
        <div>
          <label className="block text-sm font-medium">Comment:</label>
          <input
            type="text"
            name="dietaryRestrictions"
            value={formData.dietaryRestrictions}
            onChange={handleChange}
            placeholder="e.g., any comment here"
            className="w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-gray-400"
          />
        </div>

        {/* Hidden Date Input */}
        <input type="hidden" name="date" value={formData.date} />

        <button
          type="submit"
          className="w-full py-2 mt-2 bg-gray-900 text-white font-semibold rounded-md hover:bg-gray-700 transition-all"
        >
          Register
        </button>
      </form>

      {successMessage && <p className="mt-4 text-green-500">{successMessage}</p>}
      {errorMessage && <p className="mt-4 text-red-500">{errorMessage}</p>}
    </div>
  );
};

export default Register;
